import React from "react";
import { Link } from "react-router-dom";
import "./MenuPage.css";

// Import cake variation images
import cakeChocolate from "../assets/images/3 milk cake with chocolate.jpg";
import cakeCaramel from "../assets/images/3 milk cake with caramel.jpeg";
import cakeTiramisu from "../assets/images/3 milk cake with tiramisu.jpeg";
import cakeLotus from "../assets/images/3 milk cake with lotus.jpg";
import cakeBuenos from "../assets/images/3 milk cake with buenos.jpg";
import cakeOreos from "../assets/images/oreo.jpeg";
import cakePistachio from "../assets/images/3 milk cake with pistachio.jpg";
import cakeFront from "../assets/images/cake-front.png";
import chocolateCakeSpecial from "../assets/images/3 milk cake chocolate cake.jpg";
import impossibleCake from "../assets/images/impossible cake.jpg";
import burrera from "../assets/images/burrera.jpg";
import carrotCake from "../assets/images/carrot cake.jpeg";
import cupcakesMix from "../assets/images/cupcakes mix.jpg";

const MenuPage = () => {
  // Simplified menu data for display
  const menuSections = {
    signature: {
      title: "Our Signature Cakes",
      subtitle: "Authentic Venezuelan tres leches in delicious variations",
      products: [
        {
          id: "tres-leches-traditional",
          name: "Traditional Tres leches cake",
          price: "£8.50",
          image: cakeFront,
        },
        {
          id: "tres-leches-caramel",
          name: "Caramel Tres leches cake",
          price: "£9",
          image: cakeCaramel,
        },
        {
          id: "tres-leches-lotus",
          name: "Lotus Tres leches cake",
          price: "£9",
          image: cakeLotus,
        },
      ],
    },
    considering: {
      title: "More Variations",
      subtitle: "Explore our delicious range of tres leches flavors",
      products: [
        {
          id: "tres-leches-pistachio",
          name: "Pistachio Tres leches cake",
          price: "£9",
          image: cakePistachio,
        },
        {
          id: "tres-leches-chocolate",
          name: "Chocolate Tres leches cake",
          price: "£9",
          image: cakeChocolate,
        },
        {
          id: "tres-leches-bueno",
          name: "Kinder Bueno Tres leches cake",
          price: "£9",
          image: cakeBuenos,
        },
        {
          id: "tres-leches-oreo",
          name: "Oreo Tres leches cake",
          price: "£9",
          image: cakeOreos,
        },
        {
          id: "tres-leches-tiramisu",
          name: "Tiramisu Tres leches cake",
          price: "£9",
          image: cakeTiramisu,
        },
      ],
    },
    specialty: {
      title: "Also Available",
      subtitle: "Premium specialty cakes and traditional favorites",
      products: [
        {
          id: "impossible-cake",
          name: 'Impossible Cake 8"',
          price: "£42",
          image: impossibleCake,
        },
        {
          id: "carrot-cake",
          name: 'Carrot Cake 8"',
          price: "£46",
          image: carrotCake,
        },
        {
          id: "burrera",
          name: "Burrera",
          price: "From £38",
          image: burrera,
        },
      ],
    },
    cupcakes: {
      title: "Cupcakes",
      subtitle: "Individual treats perfect for any occasion",
      products: [
        {
          id: "cupcakes",
          name: "Vanilla / Chocolate / Carrot cupcakes",
          price: "£3 each",
          image: cupcakesMix,
        },
      ],
    },
    special: {
      title: "Special Item",
      subtitle: "Exclusively crafted for chocolate lovers",
      products: [
        {
          id: "chocolate-tres-leches",
          name: "Chocolate Tres leches cake",
          price: "£45",
          image: chocolateCakeSpecial,
          subtitle: "For ChocoLovers Special",
        },
      ],
    },
  };

  const ProductCard = ({ product, isComingSoon = false }) => (
    <div className={`product-card ${isComingSoon ? "coming-soon" : ""}`}>
      <Link to={`/product/${product.id}`} className="product-card-link">
        <div className="product-card-content">
          <div className="product-image-container">
            {product.image ? (
              <img
                src={product.image}
                alt={product.name}
                className="product-image"
              />
            ) : (
              <div className="product-image-placeholder">
                <span className="placeholder-text">Photo Coming Soon</span>
              </div>
            )}

            {/* Badges on top of image */}
            {isComingSoon && (
              <span className="coming-soon-badge image-badge">COMING SOON</span>
            )}

            <div className="image-overlay"></div>
            <div className="card-hover-effect">
              <svg
                className="view-icon"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M15 12L19 8L15 4M19 8H5"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span>View Details</span>
            </div>
          </div>
          <div className="product-info">
            {product.subtitle && (
              <p className="product-subtitle">{product.subtitle}</p>
            )}
            <h3 className="product-name">{product.name}</h3>
            <p className="product-price">{product.price}</p>
          </div>
        </div>
      </Link>
    </div>
  );

  return (
    <div className="menu-page">
      {/* Background Elements */}
      <div className="menu-background">
        <div className="background-shape shape-1"></div>
        <div className="background-shape shape-2"></div>
        <div className="background-shape shape-3"></div>
      </div>

      <div className="menu-container">
        {/* Render each section with enhanced styling */}
        {Object.entries(menuSections)
          .filter(
            ([sectionKey]) =>
              sectionKey !== "cupcakes" && sectionKey !== "special",
          )
          .map(([sectionKey, section]) => (
            <section
              key={sectionKey}
              className={`menu-section section-${sectionKey}`}
            >
              <div className="section-header">
                <div className="section-text">
                  <h2 className="section-title">{section.title}</h2>
                </div>
              </div>
              <div className="products-grid">
                {section.products.map((product, index) => (
                  <ProductCard
                    key={index}
                    product={product}
                    isComingSoon={product.isComingSoon || false}
                  />
                ))}
              </div>
            </section>
          ))}

        <div className="cupcakes-special-section">
          {["cupcakes", "special"].map((sectionKey) => {
            const section = menuSections[sectionKey];
            return (
              <section
                key={sectionKey}
                className={`menu-section section-${sectionKey}`}
              >
                <div className="section-header">
                  <div className="section-text">
                    <h2 className="section-title">{section.title}</h2>
                  </div>
                </div>
                <div className="products-grid">
                  {section.products.map((product, index) => (
                    <ProductCard key={index} product={product} />
                  ))}
                </div>
              </section>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default MenuPage;
